import axiosInstance from "../../global/actions/main.api";
import { apiConfigGuest, BACKEND_URL } from '@/global/actions/apiVariables';

export const confirmRegistration = (id: string) => {
    return axiosInstance.get(`${BACKEND_URL}/register-appeals/email/${id}`, apiConfigGuest);
};